import { useQuery } from '@vue/apollo-composable'
import gql from 'graphql-tag'
import { computed } from 'vue'
import { ACTIVE_COMPLIANCES_ON_ACCOUNT_FRAGMENT } from '@/components/compliances/queries/Compliances'
import { freelancerOnboardingCompliances } from '@/components/compliances/types/ComplianceName.enum'

/**
 * Composable for managing freelancer onboarding compliance state
 * Checks if a freelancer has completed all required onboarding compliances
 */
export function useFreelancerOnboardingCompliances() {
  const complianceNames = freelancerOnboardingCompliances()

  const { result: resultAccount, loading: loadingAccount } = useQuery(
    gql`
      query accountQuery($complianceNames: [ComplianceName!]!) {
        me {
          activeAccount {
            __typename
            name

            ...ActiveCompliancesOnAccount
          }
        }
      }
      ${ACTIVE_COMPLIANCES_ON_ACCOUNT_FRAGMENT}
    `,
    {
      complianceNames,
    },
  )

  const activeAccount = computed(() => resultAccount?.value?.me?.activeAccount)

  const isFreelancerOnboarded = computed(
    () =>
      activeAccount.value?.compliances?.every(
        (compliance) => !compliance.isApplicable || compliance.isComplete,
      ) ?? false,
  )

  return {
    activeAccount,
    isFreelancerOnboarded,
    loadingAccount,
  }
}
